// extracted by mini-css-extract-plugin
export default {"root":"Copy_root__gbmHP","inView":"Copy_inView__T28kH","movein":"Copy_movein__K8OES"};